(() => {
 function alignArticle(){
  const main=document.getElementById('MainContent'),article=main?.querySelector('.article-template'),header=article?.querySelector(':scope > header.page-width');
  if(!header)return;
  const content=article.querySelector('[itemprop="articleBody"]');
  const custom=main.querySelector('.lle-booking-article,.lle,.ll-storehouse,.ll-fenix,.ll-marble,.lise-af,.lise-ddw,.lise-zero,.llh,.ll-gent,.ll-pine-story,.lise-forward,.ll-lucas,.ll-lucile,.lise-bm');
  const root=content?.textContent.trim()?content:custom;
  if(!root)return;
  const target=[...root.querySelectorAll('p')].find(p=>p.textContent.trim().length>80&&!p.closest('aside,.lle-booking-card,.llh__card,figcaption'));
  if(!target)return;
  const share=article.querySelector('.article-template__social-sharing');let frame;
  function update(){cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
   const box=target.getBoundingClientRect(),base=article.getBoundingClientRect();
   if(!box.width)return;
   const left=Math.max(0,box.left-base.left);
   [header,share].filter(Boolean).forEach(el=>{el.style.width=box.width+'px';el.style.maxWidth='none';el.style.paddingInline='0';el.style.marginLeft=left+'px';el.style.marginRight='0';});
   const title=header.querySelector('h1');if(title)title.style.maxWidth='100%';
  });}
  if('ResizeObserver'in window)new ResizeObserver(update).observe(target);else addEventListener('resize',update,{passive:true});
  if(document.fonts)document.fonts.ready.then(update);update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',alignArticle);else alignArticle();
})();
